import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createCheckout,
  createPortal,
  getWorkspaceSubscription,
  listPlans,
} from "@/lib/api/billing";

export const billingKeys = {
  subscription: (workspaceId: string) => ["billing", "subscription", workspaceId] as const,
  plans: ["billing", "plans"] as const,
};

/** The business's subscription row, or null on the trial and after it. */
export function useWorkspaceSubscription(workspaceId: string | undefined) {
  return useQuery({
    queryKey: billingKeys.subscription(workspaceId ?? ""),
    queryFn: () => getWorkspaceSubscription(workspaceId!),
    enabled: Boolean(workspaceId),
  });
}

export function usePlans(enabled = true) {
  return useQuery({ queryKey: billingKeys.plans, queryFn: listPlans, enabled });
}

/** Resolves with the Checkout URL; the page redirects the browser there. */
export function useCheckout() {
  return useMutation({ mutationFn: createCheckout });
}

export function usePortal() {
  return useMutation({ mutationFn: createPortal });
}

export function useInvalidateSubscription() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["billing", "subscription"] });
}
